import React, { PureComponent } from 'react';

import CoreUtils from '../utils/CoreUtils';

import QuickEntryConfigurationUtils from '../value-types/QuickEntryConfigurationUtils';

export default class QuickEntryConfigurationEditor extends PureComponent {
  constructor(props) {
    super(props);

    this.hlhListener = this.onHLHChanged.bind(this);
    this.llhListener = this.onLLHChanged.bind(this);
    this.atcListener = this.onATCChanged.bind(this);

    this.hlhEnabled = false;
    this.llhEnabled = false;
    this.atcEnabled = false;
  }

  updateCompositeValues() {
    var quickEntryConfiguration = QuickEntryConfigurationUtils.deserializeValues(this.props.value);
    if (CoreUtils.isDefinedAndNotNull(quickEntryConfiguration)) {
      this.hlhEnabled = quickEntryConfiguration.hlh;
      this.llhEnabled = quickEntryConfiguration.llh;
      this.atcEnabled = quickEntryConfiguration.atc;
    }
    else {
      this.hlhEnabled = false;
      this.llhEnabled = false;
      this.atcEnabled = false;
    }
  }

  render() {
    this.updateCompositeValues();

    return (
      <div className="pwx-quick-entry-configuration-editor">
        <table><tbody>
          <tr>
            <td>HLH:</td>
            <td>
              <div className="pwx-value-separator" />
            </td>
            <td>
              <input
                className="pwx-boolean-editor"
                checked={this.hlhEnabled}
                disabled={this.props.disabled}
                onChange={this.hlhListener}
                type="checkbox"
              />
            </td>
            <td>
              <div className="pwx-field-separator" />
            </td>
            <td>LLH:</td>
            <td>
              <div className="pwx-value-separator" />
            </td>
            <td>
              <input
                className="pwx-boolean-editor"
                checked={this.llhEnabled}
                disabled={this.props.disabled}
                onChange={this.llhListener}
                type="checkbox"
              />
            </td>
            <td>
              <div className="pwx-field-separator" />
            </td>
            <td>ATC:</td>
            <td>
              <div className="pwx-value-separator" />
            </td>
            <td>
              <input
                className="pwx-boolean-editor"
                checked={this.atcEnabled}
                disabled={this.props.disabled}
                onChange={this.atcListener}
                type="checkbox"
              />
            </td>
            <td>
              <div className="pwx-field-right-margin" />
            </td>
          </tr>
        </tbody></table>
      </div>
    );
  }

  onHLHChanged(event) {
    this.hlhEnabled = event.target.checked;
    this.handleValueEditChange();
  }

  onLLHChanged(event) {
    this.llhEnabled = event.target.checked;
    this.handleValueEditChange();
  }

  onATCChanged(event) {
    this.atcEnabled = event.target.checked;
    this.handleValueEditChange();
  }

  handleValueEditChange() {
    var value = QuickEntryConfigurationUtils.serializeValues({
      hlh: this.hlhEnabled,
      llh: this.llhEnabled,
      atc: this.atcEnabled
    });

    if (CoreUtils.isDefinedAndNotNull(this.props.onValueChanged))
      this.props.onValueChanged(this.props.name, value);
  }
}